import { useEffect, useState } from "react";

type Props = {
  CTA: string;
  variant?: string;
  onClick?: any;
  buttonType?: "submit" | "reset" | "button";
  style?: React.CSSProperties;
  disabled?: boolean;
};

const ButtonComponent = ({ CTA = "button", variant = "secondary", onClick = () => {}, buttonType = "button", style, disabled = false }: Props) => {
  const [color, setcolor] = useState("bg-primary text-white");

  // Check if backgroundColor is provided in style prop
  const hasCustomBgColor = style?.backgroundColor !== undefined;

  useEffect(() => {
    if (disabled) {
      setcolor("bg-gray-300 text-gray-500 cursor-not-allowed");
    } else {
      switch (variant) {
        case "secondary":
          setcolor(hasCustomBgColor ? "text-white" : "bg-secondary text-white");
          break;
        case "danger":
          setcolor(hasCustomBgColor ? "text-white" : "bg-utils-danger text-white");
          break;
        case "sold-out":
          setcolor(hasCustomBgColor ? "text-white" : "bg-utils-sold-out text-white");
          break;
        case "success":
          setcolor("text-white");
          break;
        case "primary":
          setcolor(hasCustomBgColor ? "text-white" : "background-primary text-white");
          break;
        case "dynamic":
          setcolor(hasCustomBgColor ? "text-white" : "background-secondary text-white");
          break;
        default:
          setcolor(hasCustomBgColor ? "text-white" : "bg-primary text-white");
          break;
      }
    }
  }, [variant, disabled, hasCustomBgColor]);

  return (
    <>
      <button
        type={buttonType}
        onClick={() => !disabled && onClick()}
        disabled={disabled}
        style={style}
        className={`py-[12px] font-bold rounded-[10px] w-full px-4 focus:outline-none transition-all duration-200 ${
          disabled ? "cursor-not-allowed" : "cursor-pointer hover:opacity-90"
        } ${color}`}
      >
        {CTA}
      </button>
    </>
  );
};

export default ButtonComponent;
